import React from 'react';
import {
  Tabs as BPTabs,
  TabsProps as ITabsProps,
  TabProps as ITabProps,
  Tab as BPTab,
  DISPLAYNAME_PREFIX
} from '@blueprintjs/core';

export const Tabs: React.FC<ITabsProps> = (props) => {
  return <BPTabs {...props} />;
};

Tabs.displayName = `${DISPLAYNAME_PREFIX}.Tabs`;

export const Tab: React.FC<ITabProps> = (props) => {
  return <BPTab {...props} />;
};

Tab.displayName = `${DISPLAYNAME_PREFIX}.Tab`;
